import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { RectangleWithRadius } from "../utils/RectangleWithRadius";
import { GameManager } from "../GameManager";
import { AudioManager } from "../AudioManager";
import { SponsorManager, WhyCallAd } from "../SponsorManager";

 export class ChallengeEndLayer extends Phaser.Group {

    private win: boolean;

    constructor(game: Phaser.Game, win: boolean) {

        super(game, null, "challenge-end-layer");

        this.win = win;

        const transparentLayer = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        transparentLayer.scale.set(GameConstants.GAME_WIDTH / 64, GameConstants.GAME_HEIGHT / 64);
        transparentLayer.alpha = 0;
        transparentLayer.inputEnabled = true;
        transparentLayer.events.onInputDown.add(this.onTransparentLayer, this);
        this.add(transparentLayer);

        this.game.add.tween(transparentLayer)
            .to({alpha: .5}, 250, Phaser.Easing.Linear.None, true);

        const midContainer = new Phaser.Group(this.game);
        midContainer.x = GameConstants.GAME_WIDTH / 2;
        midContainer.y = 558;
        midContainer.scale.y = GameVars.scaleY;
        midContainer.alpha = 0;
        this.add(midContainer);

        let w = 580;
        let h = 400;

        const rectangleWithRadius = new RectangleWithRadius(this.game, -w / 2, -h / 2, w, h, 6, "#1b2d3d", .85);
        midContainer.add(rectangleWithRadius);

        const label = new Phaser.Text(this.game, 0, -120, win ? GameVars.texts[GameVars.language]["CHECKMATE"] + "!" : GameVars.texts[GameVars.language]["OUT OF MOVES"], { font: "45px Roboto Slab Regular", fill: "#FFFFFF", align: "center"});
        label.anchor.set(.5);
        midContainer.add(label);

        if (this.win) {

            const level = new Phaser.Text(this.game, 0, -45, GameVars.texts[GameVars.language]["PUZZLE"] + " " + GameVars.currentLevelName + " " + GameVars.texts[GameVars.language]["SOLVED"] + " ", { font: "40px Roboto Slab Regular", fill: "#FFFFFF", align: "center"});
            level.anchor.set(.5);
            midContainer.add(level);

            const check = new Phaser.Image(this.game, 0, 25, "texture_atlas_1", "checked_level.png");
            check.anchor.set(.5);
            midContainer.add(check);

            const buttonNext = new Phaser.Button( this.game, 0, 120, "texture_atlas_2_" + GameVars.language, this.onClickNext, this);
            buttonNext.setFrames("btn_back_to_menu_on.png", "btn_back_to_menu_off.png", "btn_back_to_menu_on.png");
            buttonNext.anchor.set(.5);
            midContainer.add(buttonNext);

            GameManager.problemSolved();
        } else {

            const buttonRetry = new Phaser.Button( this.game, 0, 10, "texture_atlas_2_" + GameVars.language, this.onClickRetry, this);
            buttonRetry.setFrames("btn_replay_on.png", "btn_replay_off.png", "btn_replay_on.png");
            buttonRetry.anchor.set(.5);
            midContainer.add(buttonRetry);

            const buttonNext = new Phaser.Button( this.game, 0, 120, "texture_atlas_2_" + GameVars.language, this.onClickNext, this);
            buttonNext.setFrames("btn_back_to_menu_on.png", "btn_back_to_menu_off.png", "btn_back_to_menu_on.png");
            buttonNext.anchor.set(.5);
            midContainer.add(buttonNext);
        }

        AudioManager.setMusicVolume(1);

        this.game.add.tween(midContainer)
            .to({alpha: 1}, 250, Phaser.Easing.Linear.None, true, 1000);
        
    }

    private onClickRetry(b: Phaser.Button): void {

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "ResetProblems";
            } else {
                GameManager.startChallengeState(true);
            }
        } else if (GameConstants.SPONSOR === GameConstants.SPONSOR_POKI) {
            if (!AudioManager.isMuted) {
                AudioManager.forceMute();
            }
            PokiSDK.commercialBreak().then(
                () => {
                    if (!AudioManager.isMuted) {
                        AudioManager.forceUnmute();
                    }
                    GameVars.onAd = false;
                    this.game.paused = false;
                    GameManager.startChallengeState(true);
                }
            );
            GameVars.onAd = true;
            this.game.paused = true;
        } else {
            SponsorManager.adFilter(() => {
                GameManager.startChallengeState(true);
            }, this.game, WhyCallAd.onClickRetry);
        } 

        AudioManager.playSound("click"); 
    }

    private onClickNext(b: Phaser.Button): void {

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "ProblemsMenu";
            } else {
                GameManager.enterProblemSelectionState(GameVars.puzzleMoves);
            }
        } else {
            SponsorManager.adFilter(() => {
                GameManager.enterProblemSelectionState(GameVars.puzzleMoves, true);
            }, this.game, WhyCallAd.onClickHome);
        } 

        AudioManager.playSound("click"); 
    }

    private onTransparentLayer(): void {
        // 
    }
}

